import axios from 'axios'

const serve = axios.create({
  baseUrl: '/api',
  timeout: 5000
})
serve.defaults.headers.post['Content-Type'] = 'application/json'
serve.interceptors.request.use(function (config) {
  return config
},
error => {
  return Promise.reject(error)
})
serve.interceptors.response.use(response => {
  return response.data
},
error => {
  // if(error.response.status==504){
  // Message.error('服务器异常，请联系管理员！');
  // }
  return Promise.reject(error)
})

export default serve



// WEBPACK FOOTER //
// ./src/service/index.js